// extracted by mini-css-extract-plugin
export default {"scrollArea":"StockedItemsDisplayList_scrollArea__QZoHK","newStockedItems":"StockedItemsDisplayList_newStockedItems__DNfgJ"};